import './submit-form';

// WOW animated
const wow = new WOW({
    boxClass:     'wow', // default
    animateClass: 'animated', // default
    offset:       0, // default
    mobile:       true, // default
    live:         true // default
});
wow.init();

// BenedenBoven cookiescript
new CookieNotification({
    privacyPage: '/voorwaarden/privacyverklaring'
});

if(document.querySelector('#mainNav')) {
    let scrollpos    = window.scrollY;
    let oldScrollPos = 0;
    const mainNav    = document.querySelector("#mainNav");
    const navHeight  = mainNav.offsetHeight;

    const addClassOnScroll    = () => mainNav.classList.add("navbar-shrink")
    const removeClassOnScroll = () => mainNav.classList.remove("navbar-shrink")

    window.addEventListener('scroll', () => {
        scrollpos = window.scrollY;

        // If scrolled up, remove classes as well
        if(scrollpos < oldScrollPos) {
            removeClassOnScroll()
            oldScrollPos = scrollpos;
            return;
        }

        if(scrollpos >= navHeight) {
            addClassOnScroll()
        } else {
            removeClassOnScroll()
        }

        oldScrollPos = scrollpos;
    });
}

if(document.querySelector('.navbar-brand')) {
    const navbarBrand = document.querySelector('.navbar-brand');
    setInterval(() => {
        navbarBrand.classList.toggle('animate-out');
    }, 5000);
}

(function($) {
    "use strict"; // Start of use strict

    // Append .background-image-holder <img>'s as CSS backgrounds
    $('.background-image-holder').each(function() {
        var imgSrc = $(this).children('img').attr('src');
        $(this).css('background', 'url("' + imgSrc + '")');
        $(this).children('img').hide();
        $(this).css('background-position', 'initial');
    });

    // MAP
    $('.map-holder').click(function() {
        $(this).addClass('interact');
    });

    if($('.map-holder').length) {
        $(window).scroll(function() {
            if($('.map-holder.interact').length) {
                $('.map-holder.interact').removeClass('interact');
            }
        });
    }

    // Smooth scrolling using jQuery easing
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
        if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target     = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if(target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 150
                }, 1000, "easeInOutExpo");
                return false;
            }
        }
    });

    // Parallax header
    $(function() {
        // 	init scrollmagic
        var controller = new ScrollMagic.Controller();

        // 	loop through slides
        $(".page-title").each(function() {

            var bg = $(this).find(".background-image");

            // Add tweenmax for backgroundParallax
            var parallax = TweenMax.from(bg, 1, {
                y:    '-15%',
                ease: Power0.easeNone
            });

            // Create scrollmagic scene
            var parallaxScene = new ScrollMagic.Scene({
                triggerElement: this, // <-- Use this to select current element
                triggerHook:    1,
                duration:       '200%',
            })
                .setTween(parallax)
                .addTo(controller);
        });
    });

    // Mouse parallax
    var rect  = $('section')[0].getBoundingClientRect();
    var mouse = {
        x:     0,
        y:     0,
        moved: false
    };

    $("section").mousemove(function(e) {
        mouse.moved = true;
        mouse.x     = e.clientX - rect.left;
        mouse.y     = e.clientY - rect.top;
    });

    // Ticker event will be called on every frame
    TweenLite.ticker.addEventListener('tick', function() {
        if(mouse.moved) {
            parallaxIt(".large", -10);
            parallaxIt(".mouse-move", -10);
            parallaxIt(".footer-logo", -3);
            parallaxIt(".home-icon", -7);
            parallaxIt(".blocks-home", -20);
            parallaxIt(".slide-text", -8);
        }
        mouse.moved = false;
    });

    function parallaxIt(target, movement) {
        TweenMax.to(target, 0.4, {
            x: (mouse.x - rect.width / 2) / rect.width * movement,
            y: (mouse.y - rect.height / 2) / rect.height * movement
        });
    }

    $(window).on('resize scroll', function() {
        rect = $('section')[0].getBoundingClientRect();
    })

    // Flickity
    $('.carousel').flickity({
        percentPosition: false,
        prevNextButtons: false,
        freeScroll:      true,
        contain:         true,
        wrapAround:      false,
        groupCells:      2
    });

    // Flickity
    $('.carousel-employees').flickity({
        percentPosition: false,
        prevNextButtons: false,
        freeScroll:      true,
        contain:         true,
        wrapAround:      true,
        groupCells:      3
    });

    // Gridzy
    $('.gridzy').gridzy({
        spaceBetween:  20,
        desiredHeight: 400
    });
    $('.gridzy-about').gridzy({
        spaceBetween:  20,
        desiredHeight: 250
    });

    // Modulobox
    var modulobox = new ModuloBox({
        mediaSelector:      '.gallery figure > a, .hidden-gallery div',
        loop:               3,
        history:            true,
        controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
        shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
        videoMaxWidth:      1440,
        minZoom:            1,
        zoomTo:             1.8,
        mouseWheel:         false,
        contextMenu:        false,
        scrollToZoom:       true,
        captionSmallDevice: false,
        thumbnails:         true,
        thumbnailsNav:      'centered',
        thumbnailSizes:     {
            1920: {
                width:  110,
                height: 80,
                gutter: 10
            },
            1280: {
                width:  90,
                height: 65,
                gutter: 10
            },
            680:  {
                width:  0,
                height: 0,
                gutter: 0
            }
        }
    });

    modulobox.on('beforeOpen.modulobox', function(gallery, index) {
        if(window.cubeRAF) {
            cancelAnimationFrame(window.cubeRAF);
            window.cubeRAF = false;
        }
    });

    modulobox.on('afterClose.modulobox', function(gallery, index) {
        if(typeof Event === 'function' && !window.cubeRAF) {
            window.dispatchEvent(new Event('scroll'));
        }
    });

    modulobox.init();

    // Closes responsive menu when a scroll trigger link is clicked
    $('.js-scroll-trigger').click(function() {
        $('.navbar-collapse').collapse('hide');
    });

})(jQuery); // End of use strict
